module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#edit",
      toString: function () {
        return this.url;
      }
    }